import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {selectRedirectUrl} from 'app/hooks/reduxCreateSelectorHooks';
import {BackToOptions} from 'app/components/emailForm/BackToOptions';
import {LegalNote} from 'app/components/legal/LegalNote';
import {MainLayout} from 'app/components/MainLayout';
import {EmailFormLogin} from 'app/components/emailForm/EmailFormLogin';
import {EmailFormSignUp} from 'app/components/emailForm/EmailFormSignUp';
import {string, oneOf} from 'prop-types';
import {useLocation} from 'react-router';
import {ErrorAlert} from 'app/components/error/ErrorAlert';
import {LoadingOverlay} from 'app/components/loading/LoadingOverlay';
import {logLoginError} from 'app/services/firebase';

const AuthPageWithEmail = props => {
  const {type, headline, subtitle, backToOptionsText, backToOptionsLink} = props;
  const redirectUrl = useSelector(selectRedirectUrl);
  const [isLoadingEmailAuth, setIsLoadingEmailAuth] = useState(false);
  const [error, setError] = useState(false);
  const [emailWithError, setEmailWithError] = useState('');
  const {search} = useLocation();

  const handleLoadingEmailAuth = value => {
    setIsLoadingEmailAuth(value);
  };

  const handleError = (error, email) => {
    setIsLoadingEmailAuth(false);
    setEmailWithError(email);
    setError(error);
    if (error) {
      logLoginError(error, email, 'password');
    }
  };

  const backToOptions = <BackToOptions to={{pathname: backToOptionsLink, search}} text={backToOptionsText} />;

  let title = headline;
  const emailAuthContent = {
    signup: () => (
      <EmailFormSignUp
        setShowLoading={value => handleLoadingEmailAuth(value)}
        onError={(error, email) => handleError(error, email)}
      />
    ),
    login: () => (
      <EmailFormLogin
        redirectUrl={redirectUrl}
        setShowLoading={value => handleLoadingEmailAuth(value)}
        onError={(error, email) => handleError(error, email)}
      />
    ),
  };

  let authContent = emailAuthContent[type]();
  const showError = error ? <ErrorAlert error={error} email={emailWithError} /> : null;

  return (
    <>
      <LoadingOverlay open={isLoadingEmailAuth} />
      <MainLayout backToOptions={backToOptions} title={title} subtitle={subtitle}>
        {authContent}
        {showError}
      </MainLayout>
      <LegalNote />
    </>
  );
};

export default AuthPageWithEmail;

AuthPageWithEmail.propTypes = {
  type: oneOf(['login', 'signup']).isRequired,
  headline: string.isRequired,
  subtitle: string,
  backToOptionsText: string.isRequired,
  backToOptionsLink: string.isRequired,
};
